import React, { useEffect, useState } from 'react';

import { useHistory } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import CloseIcon from '@material-ui/icons/Close';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Snackbar from '@material-ui/core/Snackbar';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import ConversationsTable from './TextMessaging/ConversationsTable';


const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(3),
    },
    inputField: {
        '& .MuiTextField-root': {
            width: '40ch',
        },
    },
    textMessageInputField: {
        '& .MuiTextField-root': {
            width: '80ch',
        },
    },
    loader: {
        height: 45
    }
}));

const getSearchString = () => {
    const urlParams = new URLSearchParams(window.location.search);
    let search = urlParams.get('search');
    if (!search) {
        return '';
    }
    search = search.trim();
    if (search.indexOf("1") === 0) {
        search = '+' + search
    }
    return search
}

const TextMessagingConversations = () => {
    useEffect(() => {
        document.title = 'Text Messaging Conversation';
    }, []);

    const history = useHistory();
    const classes = useStyles();

    const handleBack = () => {
        history.push('/admin/sms');
    }

    const search = getSearchString();

    const [state, setState] = useState({
        loading: false,
        recipient: search,
        message: '',
        showSnackbar: false,
        snackbarMessage: '',
        forceReload: false
    });

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setState({
            ...state,
            showSnackbar: false
        });
    };

    const handleMessageChange = (event) => {
        setState({
            ...state,
            message: event.target.value
        });
    }

    const handleSubmit = () => {
        if (!state.message || !state.recipient) {
            alert('Missing one of the following: message, recipient');
            return;
        }
        setState({
            ...state,
            loading: true
        });
        const formData = new FormData();
        formData.append('_token', window._token);
        formData.append('messageField', state.message);
        formData.append('recipient', state.recipient);
        let url = `/admin/sms/send`;
        fetch(url, {
            method: 'POST',
            body: formData
        })
        .then(response => {
            if (response.status === 403) {
                return false
            } else {
                return response.json();
            }
        })
        .then(result => {
            if (result) {
                setState(prev => ({
                    ...prev,
                    message: '',
                    loading: false,
                    showSnackbar: true,
                    snackbarMessage: 'Successfully sent message',
                }));
            } else {
                setState(prev => ({
                    ...prev,
                    message: '',
                    loading: false,
                    showSnackbar: true,
                    snackbarMessage: 'Cannot send to recipient who has blocked SMS messages.',
                }));
            }
        })
        .then(() => {
            setTimeout(() => {
                setState(prev => ({
                    ...prev,
                    forceReload: !prev.forceReload
                }))
            }, 1000);
        })
        .catch(reason => {
            setState(prev => ({
                ...prev,
                loading: false
            }));
            alert('An error prevented submitting. Please try again.');
        })
    }

    return (
        <Box>
            <Box mb={2}>
                <Button startIcon={<Icon>chevron_left</Icon>} size="small" onClick={handleBack} variant="outlined" color="primary">Back</Button>
            </Box>
            <Paper square className={classes.paper}>
                <Typography variant="h6">Send Text Message</Typography>
                <Box className={classes.inputField}>
                    <Box mt={2} mb={1}>
                        <Typography variant="subtitle2">Recipient</Typography>
                    </Box>
                    <TextField
                        value={state.recipient}
                        variant="outlined"
                        disabled
                    />
                </Box>
                <Box className={classes.textMessageInputField}>
                    <Box mt={2} mb={1}>
                        <Typography variant="subtitle2">Message</Typography>
                    </Box>
                    <TextField
                        value={state.message}
                        onChange={handleMessageChange}
                        placeholder="Enter text message"
                        variant="outlined"
                        multiline
                        rows={5}
                    />
                    <Box mt={2}>
                        <Button disabled={!state.message || state.loading} variant="contained" color="primary" onClick={handleSubmit}>Send</Button>
                    </Box>
                </Box>
                <Box mt={2}>
                    <Typography variant="h6">Conversation History</Typography>
                </Box>
                <ConversationsTable search={search} forceReload={state.forceReload} />
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={state.showSnackbar}
                    autoHideDuration={8000}
                    onClose={handleCloseSnackbar}
                    message={state.snackbarMessage}
                    action={
                        <React.Fragment>
                            <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackbar}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </React.Fragment>
                    }
                />
            </Paper>
        </Box>
    );
}

export default TextMessagingConversations;
